import $ from 'jquery';
import MicroModal from 'micromodal';
// 就職活動の状況の確認モーダル
const jobStatusText = () => {
    const jobStatus = $('#modal-job-status-login input[name="job_status_login"]:checked').val();
    if ($('#modal-job-status-login input[type=radio][name=job_status_login]:checked').is(':checked')) {
        $('#modal-job-status-login .js-job-status-submit').removeAttr('disabled');
    } else {
        $('#modal-job-status-login .js-job-status-submit').attr('disabled', 'disabled');
    }
    if (jobStatus === '4') {
        // 就職活動終了を選択した場合
        $('#modal-job-status-login .js-job-status-text').fadeIn();
    } else {
        // それ以外の場合
        $('#modal-job-status-login .js-job-status-text').fadeOut();
    }
};

const setup = (modal) => {
    // ラジオボタンの選択によって表示を動かす
    $(document).on('change', '#modal-job-status-login input[name="job_status_login"]', (event) => jobStatusText());
    jobStatusText();

    // 更新するボタン
    $(document).on(oEventNames.end, '#modal-job-status-login .js-job-status-submit', function (event) {
        if (!bIsScrolling) {
            event.preventDefault();
            // postするデータ
            const jobStatus = $('#modal-job-status-login input[name="job_status_login"]:checked').val();
            const postData = { jobStatus };

            $.ajax({
                headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') },
                url: '/ajax/users/job-status',
                type: 'POST',
                dataType: 'json',
                data: postData,
            })
                // Ajaxリクエストが成功した時発動
                .done((data) => {
                    // mypageを表示しているなら「就職活動の状況」の欄と編集モーダルがあるので更新する
                    // 編集モーダルの選択先を更新
                    $(`#modal-job-status input[name="job_status"][value="${jobStatus}"]`).prop('checked', true);
                    // 就職活動の状況の表示を更新
                    $('#job-status-text').text(data.jobStatusText);
                    // メッセージ・受信設定の表示を更新
                    if (data.messageOffer) {
                        $('#message-offer-checkbox').addClass('check');
                    } else {
                        $('#message-offer-checkbox').removeClass('check');
                    }
                    $.toast({
                        heading: '就職活動の状況を保存しました。',
                        text: '',
                        showHideTransition: 'slide',
                        icon: 'success',
                        position: 'bottom-right',
                        hideAfter: 6000,
                    });
                })
                // Ajaxリクエストが失敗した時発動
                .fail((data) => {
                    $.toast({
                        heading: '就職活動の状況の保存に失敗しました。',
                        text: 'お手数ですが、再度お試しいただき、それでも失敗する場合はお問い合わせくださいませ。',
                        showHideTransition: 'slide',
                        icon: 'error',
                        position: 'bottom-right',
                        hideAfter: 6000,
                    });
                })
                // Ajaxリクエストが成功・失敗どちらでも発動
                .always((data) => {
                    // 何らかの理由で失敗が連続するとモーダルの後に進めなくなるので失敗でも先に進める
                    MicroModal.close('modal-job-status-login');
                });
        }
    });
};

const modalJobStatusLogin = {
    modalId: 'modal-job-status-login',
    preventEscapeKey: true,
    onShowExtra: null,
    onCloseExtra: null,
    setup,
};

export default modalJobStatusLogin;
